import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
// components
import { PdpRespSidebarBlurbShipping } from './PdpRespSidebarBlurbShipping';
import { PdpSharedBlurbDesignYourOwn } from '../PdpSharedBlurbs/PdpSharedBlurbDesignYourOwn';
import { PdpSharedBlurbLeadTime } from '../PdpSharedBlurbs/PdpSharedBlurbLeadTime';

// styles
import styles from './PdpRespSidebarBlurbs.scss';

export function PdpRespSidebarBlurbsComponent(props) {
    const { currency, viewer, item, user, displayInfo, sku } = props;
    const pricingDisplayInfo = displayInfo?.pricing || null;
    const hasValidPricingDisplayInfo = !!pricingDisplayInfo && !pricingDisplayInfo.showUnavailable;
    const { lastTransaction, isAuctionEnabled, relevantAuctionLot } = item || {};
    const { checkoutDate, isCanceled, mostRecentOffer } = lastTransaction || {};
    const shouldRenderBlurbsForAuction =
        relevantAuctionLot?.status === 'OPEN' ||
        !!(lastTransaction && !checkoutDate && !mostRecentOffer?.isExpired && !isCanceled);
    const renderBlurbs =
        (!isAuctionEnabled && hasValidPricingDisplayInfo && !pricingDisplayInfo.showSold) ||
        shouldRenderBlurbsForAuction;
    const relayVariables = useSelector(state => state.relayVariables.variables);

    if (!renderBlurbs) {
        return null;
    }

    return (
        <div className={styles.container}>
            <PdpSharedBlurbDesignYourOwn item={item} viewer={viewer} />
            <PdpSharedBlurbLeadTime sku={sku} item={item} />
            <PdpRespSidebarBlurbShipping
                currency={currency}
                itemId={relayVariables.itemId}
                item={item}
                userId={relayVariables.userId}
                viewer={viewer}
                user={user}
                renderTooltip
                sku={relayVariables.isMultiSku ? sku : null}
                isClient={relayVariables.isClient}
            />
        </div>
    );
}

PdpRespSidebarBlurbsComponent.propTypes = {
    currency: PropTypes.string,
    viewer: PropTypes.object,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
    displayInfo: PropTypes.object,
    vipUserRelationship: PropTypes.object,
    sku: PropTypes.object,
};

export const PdpRespSidebarBlurbs = createFragmentContainer(PdpRespSidebarBlurbsComponent, {
    viewer: graphql`
        fragment PdpRespSidebarBlurbs_viewer on Viewer {
            ...PdpRespSidebarBlurbShipping_viewer
            ...PdpSharedBlurbDesignYourOwn_viewer
        }
    `,
    item: graphql`
        fragment PdpRespSidebarBlurbs_item on Item {
            isAuctionEnabled
            lastTransaction(buyerId: $userId) @include(if: $fetchUser) {
                checkoutDate
                isCanceled
                mostRecentOffer {
                    isExpired
                }
            }
            relevantAuctionLot(page: pdp) @include(if: $fetchAuction) {
                status
            }
            ...PdpSharedBlurbLeadTime_item
            ...PdpRespSidebarBlurbShipping_item
            ...PdpSharedBlurbDesignYourOwn_item
        }
    `,
    user: graphql`
        fragment PdpRespSidebarBlurbs_user on User {
            serviceId
            ...PdpRespSidebarBlurbShipping_user
            ...PdpRespSidebarBlurbShipping_user
        }
    `,
    displayInfo: graphql`
        fragment PdpRespSidebarBlurbs_displayInfo on ItemDisplayInfo {
            pricing {
                showSold
                showUnavailable
            }
        }
    `,
    sku: graphql`
        fragment PdpRespSidebarBlurbs_sku on ItemSkuType {
            ...PdpRespSidebarBlurbShipping_sku @include(if: $isMultiSku)
            ...PdpSharedBlurbLeadTime_sku
        }
    `,
});
